import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';

import CustomButton from 'components/CustomButton';

export const ToolbarWithCustomButtons = (
  disableActionButton?: boolean,
  onAdjustClick?: () => void,
  onMoveClick?: () => void,
) => () => (
  <GridToolbarContainer sx={{ display: 'flex', gap: 1.5 }}>
    <GridToolbarColumnsButton />
    <CustomButton
      size="small"
      variant="contained"
      id="button-adjustInventory"
      disabled={disableActionButton}
      onClick={onAdjustClick}
    >
      Adjust
    </CustomButton>
    <CustomButton
      size="small"
      variant="contained"
      id="button-moveInventory"
      disabled={disableActionButton}
      onClick={onMoveClick}
    >
      Move
    </CustomButton>
    <GridToolbarQuickFilter />
  </GridToolbarContainer>
);
